import _ from 'lodash';
import { stringCompare } from '../utils/trainUtils';

export const Genders = Object.freeze({
  MALE: {
    key: 'MALE',
    value: 'M',
    displayText: 'Male',
  },
  FEMALE: {
    key: 'FEMALE',
    value: 'F',
    displayText: 'Female',
  },
  OTHERS: {
    key: 'TRANSGENDER',
    value: 'T',
    displayText: 'Others',
  },
  NOT_SPECIFIED: {
    key: 'NS',
    value: 'NS',
    displayText: 'Select',
  },
});

export const isMale = (gender) => !_.isEmpty(gender) && stringCompare(Genders.MALE.key, gender.key);

export const isGenderEqual = (gender1, gender2) => {
  if (_.isEmpty(gender1) || _.isEmpty(gender2)) {
    return false;
  }
  return stringCompare(gender1.key, gender2.key);
};

export const getGenderOptions = () =>
  Object.values(Genders).filter((gender) => gender.key !== Genders.NOT_SPECIFIED.key)
    .map((gender) => ({
      id: gender.key,
      text: gender.displayText,
      obj: gender,
    }));

export const getGenderOptionsWithNotSpecified = () =>
  Object.values(Genders)
    .map((gender) => ({
      id: gender.key,
      text: gender.displayText,
      obj: gender,
    }));

export const getGender = (value) =>
  getGenderOptionsWithNotSpecified().find((gender) => gender.id === value);

export const getGenderByCode = (code) =>
  getGenderOptionsWithNotSpecified().find((gender) => gender.obj.value === code);
